import { Hero } from './Hero/Hero';
import { OpenAccount } from './OpenAccount/OpenAccount';
import { TicketHowTo } from './TicketHowTo/TicketHowTo';
import { Upcoming } from './Upcoming/Upcoming';
import { Legends } from './Legends/Legends';
import { Box } from '@chakra-ui/react';
import { useAuthCode } from 'context/AuthCodeContext/AuthCodeContext';
import { useEventTracking } from 'hooks/useEventTracking';
import { useEffect } from 'react';
import 'https://cdn.marmot-cloud.com/npm/hylid-bridge/2.10.0/index.js';

export const MatchesPage = () => {
  const { eventTracking } = useEventTracking();
  useEffect(() => {
    eventTracking.page.viewed({
      pageName: 'matches_page',
      url: window.location.href,
    });
  }, [eventTracking]);
  const { authCode, userToken } = useAuthCode();

  return (
    <Box as='div'>
      <Hero />
      <Upcoming />
      {userToken === undefined && authCode === null && (
        <Box>
          <TicketHowTo />
          <OpenAccount />
        </Box>
      )}
      <Legends />
    </Box>
  );
};
